export default function drawRandom(g, app, { origin, settings }) {
  const w = app?.renderer?.width  || 0;
  const h = app?.renderer?.height || 0;

  try { g.lineStyle({ width: 2, color: 0x00d4ff, alpha: 0.6 }); }
  catch { g.lineStyle(2, 0x00d4ff, 0.6); }

  g.drawRect(2, 2, Math.max(0, w - 4), Math.max(0, h - 4));

  // optional hint point
  const hint = settings?.randomHintOrigin;
  if (hint && Number.isFinite(hint.x) && Number.isFinite(hint.y)) {
    try { g.lineStyle({ width: 1, color: 0x00a7cc, alpha: 0.9 }); }
    catch { g.lineStyle(1, 0x00a7cc, 0.9); }
    g.drawCircle(hint.x, hint.y, 6);
  }
}
